/**
 * User: n.gorte
 * Date: 13.10.2020
 * Time: 14:21
 */

import React, { useEffect } from 'external/react';
import PropTypes from 'external/prop-types';
import { translation, WYSIWYGEditor } from 'plugin/liferay-widgets-react-web';
import { FliwasFormGrid, FliwasFormGroup, FliwasFormHeading } from './BasicFormComponents';
import { FormControl } from 'external/react-bootstrap';
import * as FormValidationUtil from '../utils/form-validation-util';

const validate = (formData) => {
    const titleValid = FormValidationUtil.validateStringMinLengthMaxLength(formData.title, 1, 140, 'Titel');
    const descriptionValid = FormValidationUtil.validateStringMinLengthMaxLength(formData.description, 1, 3999, 'Kommentar');
    return {
        title: titleValid,
        description: descriptionValid,
    };
};

export const JournalEntryAddForm = ({ formData, formValidation, onChange, editTitle = false }) => {
    useEffect(() => {
        onChange(formData, validate(formData));
    }, []);

    const change = (field) => (value) => {
        const item = formData.item || formData;
        const newData = {
            ...item,
            [field]: value
        };
        onChange(newData, validate(newData));
    };
    const titleChange = (e) => {
        const item = formData.item || formData;
        const newData = {
            ...item,
            title: e.target.value
        };
        onChange(newData, validate(newData));
    }
    

    return (
        <FliwasFormGrid>
            <FliwasFormHeading title="Journaleintrag erstellen"/>
            {
                editTitle &&
                <FliwasFormGroup
                    title={translation.trans('title')}
                    formValidation={formValidation}
                    propName={'title'}
                    required
                >
                    <FormControl
                        type="text"
                        required
                        placeholder={translation.trans('title')}
                        value={formData && formData.title ? formData.title : ''}
                        onChange={titleChange}
                    />
                </FliwasFormGroup>
            }

            <FliwasFormGroup
                title={translation.trans('comment')}
                formValidation={formValidation}
                propName={'description'}
                required
            >
                <WYSIWYGEditor
                    placeholder={translation.trans('comment')}
                    value={formData.description || ''}
                    onChange={change('description')}
                />
            </FliwasFormGroup>
        </FliwasFormGrid>
    );
};

JournalEntryAddForm.propTypes = {
    formData: PropTypes.object,
    formValidation: PropTypes.object,
    onChange: PropTypes.func,
    title: PropTypes.string,
    editTitle: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./js/components/JournalEntryAddForm.js